module.exports = __webpack_public_path__ + "images/emoji/lollipop.42e3a7c103e3a74c6b3b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/lollipop.png
// module id = j/RD
// module chunks = 14